module.exports = __webpack_public_path__ + "img/sample-report-en_US.d94faf61.png";